import React, { useState } from "react";
import styles from "./BPSCMathematics.module.css";

const BPSCMathematicsPYQ = () => {
  const [searchTerm, setSearchTerm] = useState("");

  // PYQ data from 2023 to 2026 - only 4 years, single paper each
  const pyqData = [
    // 2026 (latest)
    {
      id: 1,
      year: 2026,
      paper: {
        title: "BPSC Mathematics Optional Paper 2026",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_BPSC_PAPER_2026_ID", // Paste Paper link here
        viewLink: "https://drive.google.com/file/d/YOUR_BPSC_PAPER_2026_ID/view" // Paste Paper view link here
      }
    },
    // 2025
    {
      id: 2,
      year: 2025,
      paper: {
        title: "BPSC Mathematics Optional Paper 2025",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_BPSC_PAPER_2025_ID", // Paste Paper link here
        viewLink: "https://drive.google.com/file/d/YOUR_BPSC_PAPER_2025_ID/view" // Paste Paper view link here
      }
    },
    // 2024
    {
      id: 3,
      year: 2024,
      paper: {
        title: "BPSC Mathematics Optional Paper 2024",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_BPSC_PAPER_2024_ID", // Paste Paper link here
        viewLink: "https://drive.google.com/file/d/YOUR_BPSC_PAPER_2024_ID/view" // Paste Paper view link here
      }
    },
    // 2023
    {
      id: 4,
      year: 2023,
      paper: {
        title: "BPSC Mathematics Optional Paper 2023",
        downloadLink: "https://drive.google.com/uc?export=download&id=YOUR_BPSC_PAPER_2023_ID", // Paste Paper link here
        viewLink: "https://drive.google.com/file/d/YOUR_BPSC_PAPER_2023_ID/view" // Paste Paper view link here
      }
    }
  ];

  // Filter years based on search
  const filteredData = pyqData.filter(item => 
    item.year.toString().includes(searchTerm)
  );

  // Download handler
  const handleDownload = (link) => {
    window.open(link, "_blank");
  };

  // View handler
  const handleView = (link) => {
    window.open(link, "_blank");
  };

  return (
    <div className={styles.pyqPage}>
      <div className={styles.container}>
        {/* Header */}
        <div className={styles.header}>
          <h1 className={styles.title}>
            BPSC Mathematics Optional <span className={styles.gradient}>PYQs</span>
          </h1>
          <p className={styles.subtitle}>
            2023 - 2026 • 4 Years • Single Paper (New Pattern)
          </p>
        </div>

        {/* Important Note about Exam Pattern Change */}
        <div className={styles.noteBox}>
          <div className={styles.noteIcon}>
            <i className="fas fa-exclamation-circle"></i>
          </div>
          <div className={styles.noteContent}>
            <h4>⚠️ Important: BPSC Exam Pattern Changed (Dec 2022)</h4>
            <p>
              BPSC has changed Optional Subject Exam pattern in December 2022. 
              Now Optional paper is of <strong>100 Marks and passing only</strong>.
            </p>
          </div>
        </div>

        {/* Search Bar */}
        <div className={styles.searchSection}>
          <div className={styles.searchBox}>
            <i className="fas fa-search"></i>
            <input
              type="text"
              placeholder="Search by year (e.g., 2024)"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={styles.searchInput}
            />
            {searchTerm && (
              <button 
                className={styles.clearBtn}
                onClick={() => setSearchTerm("")}
              >
                <i className="fas fa-times"></i>
              </button>
            )}
          </div>
        </div>

        {/* Results Count */}
        <div className={styles.resultsInfo}>
          <span>Showing {filteredData.length} of {pyqData.length} years</span>
          <span className={styles.orderInfo}>(2026 → 2023)</span>
        </div>

        {/* PYQ Table - Single Paper per year */}
        <div className={styles.tableWrapper}>
          <table className={styles.pyqTable}>
            <thead>
              <tr>
                <th>Year</th>
                <th>BPSC Mathematics Optional Paper</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((item) => (
                  <tr key={item.id} className={styles.tableRow}>
                    {/* Year Column */}
                    <td className={styles.yearCell}>
                      <span className={styles.yearBadge}>{item.year}</span>
                    </td>
                    
                    {/* Paper Column */}
                    <td className={styles.paperCell}>
                      <div className={styles.paperContent}>
                        <span className={styles.paperTitle}>
                          <i className="fas fa-file-pdf"></i>
                          {item.paper.title}
                        </span>
                        <div className={styles.buttonGroup}>
                          <button 
                            className={styles.viewBtn}
                            onClick={() => handleView(item.paper.viewLink)}
                            title="View PDF"
                          >
                            <i className="fas fa-eye"></i>
                            View
                          </button>
                          <button 
                            className={styles.downloadBtn}
                            onClick={() => handleDownload(item.paper.downloadLink)}
                            title="Download PDF"
                          >
                            <i className="fas fa-download"></i>
                            Download
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2" className={styles.noData}>
                    <div className={styles.noDataContent}>
                      <i className="fas fa-search"></i>
                      <p>No results found for "{searchTerm}"</p>
                      <button 
                        className={styles.resetBtn}
                        onClick={() => setSearchTerm("")}
                      >
                        Clear Search
                      </button>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default BPSCMathematicsPYQ;